import { getPrefectureName, PrefectureCode } from "enums";
import React from "react";

type PROPS = {
  data: { prefecture_cd: string };
  disabled?: boolean;
};

const PrefectureSelect: React.FC<PROPS> = (props) => {
  const [value, setValue] = React.useState("");

  React.useEffect(() => {
    setValue(props.data.prefecture_cd);
  }, [props.data]);

  const PrefectureCodes: PrefectureCode[] = Object.entries(PrefectureCode).map(
    ([_, value]) => value
  );

  return (
    <select
      className="w-full"
      value={value}
      onChange={(e) => {
        const value = e.target.value;
        props.data.prefecture_cd = value;
        setValue(value);
      }}
      disabled={props.disabled}
    >
      <option value="">選択してください</option>
      {PrefectureCodes.map((item, index) => {
        return (
          <option key={item} value={item}>
            {getPrefectureName(item)}
          </option>
        );
      })}
    </select>
  );
};

export default PrefectureSelect;
